export default __webpack_public_path__ + "static/media/wechat.1f0050b8.png";